const makeSpotlightLocalStorageKey = (currentUserId: string): string => {
  return `lastSpotlightDate-${currentUserId}`;
};

const makeSpotlightLocalStorageValue = (date: Date): string => {
  const [todayFormatted] = date.toISOString().split('T');
  return todayFormatted;
};

// If expiryDate is null, it should only show once to user.
export const hadSpotlightPopup = (
  currentUserId: string,
  expiryDate?: Date
): boolean => {
  const localStorageKey = makeSpotlightLocalStorageKey(currentUserId);
  const lastStorageValueActual = localStorage.getItem(localStorageKey);

  if (!expiryDate) {
    return !!lastStorageValueActual;
  }

  const localStorageValueExpected = makeSpotlightLocalStorageValue(expiryDate);
  return (
    lastStorageValueActual &&
    lastStorageValueActual === localStorageValueExpected
  );
};

export const confirmSpotlightPopup = (currentUserId: string): void => {
  const localStorageKey = makeSpotlightLocalStorageKey(currentUserId);
  const localStorageValue = makeSpotlightLocalStorageValue(new Date());
  localStorage.setItem(localStorageKey, localStorageValue);
};
